import { render, staticRenderFns } from "./role_list.vue?vue&type=template&id=3bd17fa8&"
import script from "./role_list.vue?vue&type=script&lang=js&"
export * from "./role_list.vue?vue&type=script&lang=js&"
import style0 from "./role_list.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports